import React, { useState, useRef, useEffect } from "react";
import SidebarComponent from "../components/layout/sidebar/SidebarComponent";
import FooterComponent from "../components/layout/FooterComponent";
import { Navigate, Outlet, useNavigation } from "react-router-dom";
import { isUserLoggedIn } from "../utility/utils";
import Loader from "../components/new/Loader";
import { Toast } from "primereact/toast";
import { getSettings } from "../services/popularService.service";
import {
    getSettingsStorage,
    setSettingsStorage,
    setSettingsHashStorage,
} from "../utility/settings.utils";

const AuthLayout = ({ showSideBar = true }) => {
    if (!isUserLoggedIn()) return <Navigate to="/login" />;

    const hasWindow = typeof window !== "undefined";

    function getWindowDimensions() {
        const width = hasWindow ? window.innerWidth : null;
        return {
            width,
        };
    }

    const navigation = useNavigation();
    const toast = useRef(null);

    const [isSidebarVisible, setSidebarVisible] = useState(
        window.localStorage.getItem("sidebarVisible") ? true : false
    );

    const [isHover, setIsHover] = useState(false);
    const [windowDimensions, setWindowDimensions] = useState(
        getWindowDimensions()
    );

    const handleSidebar = () => {
        if (isSidebarVisible) window.localStorage.removeItem("sidebarVisible");
        else window.localStorage.setItem("sidebarVisible", "1");

        setSidebarVisible(!isSidebarVisible);
    };
    useEffect(() => {
        // Set company name as browser tab title
        // const user = getLocalUserInfo();
        // if (user?.name) {
        //     document.title = user.name;
        // }

        if (!getSettingsStorage()) {
            getSettings()
                .then((res) => {
                    if (
                        res?.data?.data &&
                        res?.headers?.["x-settings-timestamp"]
                    ) {
                        setSettingsStorage(res?.data?.data);
                        setSettingsHashStorage(
                            res?.headers?.["x-settings-timestamp"]
                        );
                    }
                })
                .catch((e) => console.log(e));
        }
    }, []);

    useEffect(() => {
        if (hasWindow) {
            function handleResize() {
                setWindowDimensions(getWindowDimensions());
            }

            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }
    }, [hasWindow]);

    useEffect(() => {
        if (windowDimensions?.width <= 640) {
            window.localStorage.removeItem("sidebarVisible");
            setSidebarVisible(false);
        }
    }, [windowDimensions]);

    let showSideBarClasses = "";
    let showStyleObject = {};
    if (showSideBar) {
        showSideBarClasses = `p-4 ${
            isSidebarVisible ? "sm:ml-64" : "sm:ml-16"
        }`;
        showStyleObject = {
            background: "#F5F5F4",
            minHeight: "calc(100dvh - 56px)",
            // minWidth: "96%",
            // maxWidth: "100%",
        };
    }

    return (
        <>
            <Toast ref={toast} />

            {showSideBar && (
                <SidebarComponent
                    isVisible={isSidebarVisible}
                    isHover={isHover}
                    setIsHover={setIsHover}
                    handleSidebarCallback={handleSidebar}
                    windowDimensions={windowDimensions}
                />
            )}

            <div
                className={`${showSideBarClasses} flex flex-col justify-between`}
                style={showStyleObject}
            >
                {navigation.state === "loading" ? (
                    <div
                        className="relative"
                        style={{ height: "calc(100dvh - 133px)" }}
                    >
                        <Loader />
                    </div>
                ) : (
                    <Outlet />
                )}
                {/*<FooterComponent />*/}
            </div>
        </>
    );
};

export default AuthLayout;
